import { create } from "zustand";

import { getFromId } from "storev2/common";
import funcs from "tools/functions";

const initialState = {
  store: {}, // Used for store the wizard data
  active: {}, // Used for render UI purposes
  trigger: null,
};

const useWizard = create((set, get) => ({
  // Deprecated structuredClone use 'record' attribute
  ...structuredClone(initialState),
  reset: () => {
    console.log("resetting wizard store...", initialState);
    // set(initialState);
    // Deprecated
    set((state) => ({ ...state, ...structuredClone(initialState) }));
    set((state) => ({ ...state, record: { store: {}, active: {} } }));
  },
  setCtx: (ctx) => set(() => ({ context: ctx })),
  setTrigger: (func) => set(() => ({ trigger: func })),
  record: {
    store: {},
    active: {},
  },
  newRecord: async (layout) => {
    const [_store, _active] = await funcs.getDefaults(0, layout);
    // console.log(
    //   "Esto no esta siendo usado pero si deberia Defaults en wizard...",
    //   _record,
    // );
    set(() => ({
      store: { ..._store },
      active: { ..._active },
      record: { store: { ..._store }, active: { ..._active } },
    }));
    return { store: { ..._store }, active: { ..._active } };
  },
  updateWizard: (rec) => {
    set((state) => ({
      active: { ...state.active, ...rec },
      store: { ...state.store, ...rec },
    }));
  },
  reload: async () => {
    const { model, layout } = get().context;
    const store = get().store;
    await get().setRecord(store.id, model, layout);
  },
  setRecord: async (id, model, layout) => {
    const res = await getFromId(id, model, layout);
    set({
      active: { ...res },
      store: { id: id },
      context: { model, layout },
    });
  },
}));

export { useWizard };
